import { authenticatedFetch, buildApiUrl, API_ENDPOINTS } from '../config/api';

class SportsService {
  constructor() {
    this.baseUrl = buildApiUrl(API_ENDPOINTS.SPORTS);
  }

  // Get all sports
  async getSports() {
    try {
      const response = await authenticatedFetch(this.baseUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      
      // La API devuelve {sports: [...]} en lugar de {data: [...]}
      return data.sports || data.data || data;
    } catch (error) {
      console.error('Error fetching sports:', error);
      throw error;
    }
  }

  // Get sports by category
  async getSportsByCategory() {
    try {
      const sports = await this.getSports();
      return this.groupSportsByCategory(sports);
    } catch (error) {
      console.error('Error fetching sports by category:', error);
      throw error;
    }
  }

  // Group sports by category
  groupSportsByCategory(sports) {
    const grouped = {};
    sports.forEach(sport => {
      if (!grouped[sport.category]) {
        grouped[sport.category] = [];
      }
      grouped[sport.category].push({
        id: sport.id, // NUEVO: Incluir ID del deporte
        value: sport.name.toLowerCase().replace(/\s+/g, '_'),
        label: sport.name,
        icon: sport.icon
      });
    });
    return grouped;
  }

  // Get a specific sport by ID
  async getSport(id) {
    try {
      const response = await authenticatedFetch(buildApiUrl(API_ENDPOINTS.SPORT(id)));
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching sport:', error);
      throw error;
    }
  }

  // Create a new sport
  async createSport(sportData) {
    try {
      const response = await authenticatedFetch(this.baseUrl, {
        method: 'POST',
        body: JSON.stringify(sportData)
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error creating sport:', error);
      throw error;
    }
  }

  // Update a sport
  async updateSport(id, sportData) {
    try {
      const response = await authenticatedFetch(buildApiUrl(API_ENDPOINTS.SPORT(id)), {
        method: 'PUT',
        body: JSON.stringify(sportData)
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error updating sport:', error);
      throw error;
    }
  }

  // Delete a sport
  async deleteSport(id) {
    try {
      const response = await authenticatedFetch(buildApiUrl(API_ENDPOINTS.SPORT(id)), {
        method: 'DELETE'
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error deleting sport:', error);
      throw error;
    }
  }
}

const sportsService = new SportsService();
export default sportsService;
